import { stopPropagation } from '../../../../utils/events'

export function useCalendarGridItemHandlers({
  isSecondaryLabelClickable,
  item,
  onClickItem,
  onClickSecondaryLabel,
}) {
  function handleClickItem(event) {
    onClickItem(item, event)
  }

  function handleClickSecondaryLabel(event) {
    if (isSecondaryLabelClickable) {
      stopPropagation(event)

      onClickSecondaryLabel(item)
    }
  }

  function getHandleClickSubItem(subItem) {
    return event => {
      stopPropagation(event)

      onClickItem(subItem, event)
    }
  }

  return {
    getHandleClickSubItem,
    handleClickItem,
    handleClickSecondaryLabel,
  }
}
